// extracted by mini-css-extract-plugin
export default {"wrapper":"Advt_wrapper__HlZMO","logo":"Advt_logo__MJ3CD","title":"Advt_title__DYJhF","qrBlock":"Advt_qrBlock__Ig998","qrCode":"Advt_qrCode__CfIiu"};